import * as designateReviewerTypes from './designateReviewerTypes'
import useDesignateReviewer from './useDesignateReviewer'
import Autocomplete from '../../../../control/autocomplete/autocomplete'
import MyAccordion from '../../../../control/accordion/accordion'
import React from 'react'
import { Grid } from '@material-ui/core'
import useTranslate from '../../../../i18n/useTranslate'
import ModeAccordion from '../modeAccordion/ModeAccordion'

//View
const DesignateReviewerView = (props: designateReviewerTypes.DesignateReviewerViewType) => {
    const translate = useTranslate()
    const {
        reviewer,
        isViewMode = false,
        title = translate.get('LABEL.DEFINE_PRELIMINARY_REVIEWER'),
        label = translate.get('LABEL.PRELIMINARY_REVIEWER_NAME'),
        reqField = true,
        onSubmitEdit,
        useAccordionMode,
        onClickModeEdit
    } = props

    const renderChild = (disabled = false) => {
        return (
            <Grid container item justify="flex-start" spacing={2}>
                <Grid item xs={12} md={12} lg={12}>
                    <Autocomplete
                        name="reviewer"
                        materialInputProps={{
                            label: label,
                            placeholder: translate.get('LABEL.PLEASE_SELECT'),
                            disabled: disabled,
                        }}
                        options={reviewer}
                        required={reqField}
                    />
                </Grid>
            </Grid>
        )
    }

    return (
        <React.Fragment>
            {useAccordionMode ? (
                <ModeAccordion
                    renderEditComponent={() => renderChild(false)}
                    renderViewComponent={() => renderChild(true)}
                    title={title}
                    onConfirm={onSubmitEdit}
                    onClickEdit={onClickModeEdit}
                    fieldNames={['reviewer']}
                    isViewMode={true}
                />
            ) : (
                <MyAccordion title={title}>{renderChild(isViewMode)}</MyAccordion>
            )}
        </React.Fragment>
    )
}

//Controller
const DesignateReviewer = (props: designateReviewerTypes.DesignateReviewerType) => {
    const { isViewMode } = props
    const designateReviewerModel = useDesignateReviewer(props)
    return <DesignateReviewerView {...designateReviewerModel} isViewMode={isViewMode} {...props} />
}

export default DesignateReviewer
